<template>
  <div class="consult_detail">
    <mt-header fixed title="咨询详情" style="background:#ffffff;color:#262626;">
      <router-link to="/consult" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
      <mt-button slot="right">
        <div class="right_btn_box isSelf" v-if="detailData.like_action==2">
          <img class="good-icon" src="../assets/images/n_appreciate_select@2x.png" alt="">有用{{detailData.like_count}}
        </div>
        <div class="right_btn_box" v-else>
          <img class="good-icon" src="../assets/images/n_appreciate_normal@2x.png" alt="">有用{{detailData.like_count}}
        </div>
      </mt-button>
    </mt-header>
    <div class="list_box">
      <div class="item" v-for="(item, index) in detailData.posts" 
        :class="{'answer': item.type==3, 'second': item.type==2}" :key="index">
        <p class="p_12">{{item.created_at}}</p>
        <p class="fixed_p" v-if="item.type==2">第{{["一", "二", "三"][item.typeCount]}}次补充提问</p>
        <div class="con_box">
          <div class="user_box">
            <img :src="item.avatar_url || user_img"/>
            <span>{{item.username}}</span>
          </div>
          <div class="text_con">
            <p class="p_13">{{item.content}}</p>
            <div class="img_box">
              <img
                class="previewer-demo-img"
                v-for="(imgItem, imgIndex) in item.images"
                :src="imgItem.thumb"
                width="100"
                @click.stop="show(imgIndex, item.images)"
                :key="index + '_' + imgIndex"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <previewer ref="previewer" :list="list" :options="options"> </previewer>
  </div>
</template>

<script>
  import user_img from '../assets/images/bg_consult_anonymous@2x.png';
  export default {
    metaInfo: {
      title: '',
      meta: [{
        name: 'keyWords',
        content: ''
      },{
        name: 'description',
        content: ''
      }]
    },
    data(){
      return{
        detailData: {},
        list: [],
        options: {
          getThumbBoundsFn(index) {
            let thumbnail = document.querySelectorAll('.previewer-demo-img')[
              index
              ];
            let pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            let rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        },
        user_img: user_img
      }
    },
    mounted(){
      
    },
    created(){
      
      this.getDetail();
    },
    methods:{
      submitGood(access_token){
        let info = {
          id: this.$route.params.id,
          is_anonymous: 1,
          like_it: this.detailData.like_action == 2 ? 0 : 1,
          access_token: access_token
        }
        this.$store.dispatch('setGood',info).then((res)=>{
          let result = res.data;
          if(result.code == 0){
            this.getDetail();
          }
        })
      },
      async goodBtn(){
        let access_token = localStorage.access_token
        if(access_token){
          let expire_time = localStorage.expire_time;
          let now = new Date().getTime()
          if(expire_time <= now){
            await new Promise(this.refreshToken);
            let access_token = localStorage.access_token
            this.submitGood(access_token)
          }else {
            this.submitGood(access_token)
          }
        }else {
          this.$router.push({name:"login",query:{redirectUrl: this.$route.path, entryButton: '点赞按钮'}})
        }
      },
      show(index,imgList) {
        // 显示特定index的图片，使用ref
        this.list = imgList;
        setTimeout(() => {
          this.$refs.previewer.show(index);
        },100)
      },
      getDetail(){
        let access_token = localStorage.access_token
        let info = {
          id: this.$route.params.id
        }
        this.$store.dispatch('getConsultDetail',info).then((res)=>{
          let result = res.data;
          if(result.code == 0){
            var typeCount = 0;
            result.data.posts && result.data.posts.map((item, index) => {
              if(item.type==2){
                item.typeCount = typeCount++;
              }
              item.images && item.images.map((imgItem, imgIndex) => {
                imgItem.msrc = imgItem.url;
                imgItem.src = imgItem.url;
              })
            })
            this.detailData = result.data;

            let titleEl = document.querySelector('title')
            if(this.detailData.seo_title){
              titleEl.innerHTML = this.detailData.seo_title
            }

            let keyWordsEl = document.querySelector("meta[name='keyWords']")
            if(this.detailData.seo_keywords){
              keyWordsEl.content = this.detailData.seo_keywords
            }
            
            let descriptionEl = document.querySelector("meta[name='description']")
            if(this.detailData.seo_description){
              descriptionEl.content = this.detailData.seo_description
            }
          }
        }).catch(e => {
          this.$toastlj(e.response.data.message)
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  @import '../assets/css/base.scss';
  .consult_detail {
    padding-top: pxtorem(42px);
    height: 100%;
    box-sizing: border-box;
    .right_btn_box {
      font-size: pxtorem(14px);
      color: #999;
      display: flex;
      align-items: center;
      line-height: pxtorem(20px);
      &.isSelf {
        color: #FF9300;
      }
      .good-icon {
        width: pxtorem(18px);
        height: pxtorem(17px);
        margin-right: pxtorem(2px);
      }
    }
    .list_box {
      padding-bottom: pxtorem(43px);
      background: #F2F5FA;
      .item {
        padding-top: pxtorem(20px);
        position: relative;
        &.second {
          padding-top: pxtorem(76px);
        }
        .fixed_p {
          position: absolute;
          left: 0;
          top: pxtorem(30px);
          width:pxtorem(115px);
          height:pxtorem(26px);
          background:rgba(255,147,0,1);
          border-radius:0px pxtorem(13px) pxtorem(13px) 0px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: pxtorem(13px);
        }
        &.answer {
          .con_box {
            background: #CCE3FF;
            color: #262626;
          }
        }
        .p_12 {
          font-size: pxtorem(12px);
          color: #999;
          text-align: center;
          margin-bottom: pxtorem(12px);
        }
        .con_box {
          width: calc(100% - 28px);
          padding: pxtorem(16px) pxtorem(29px) pxtorem(20px) pxtorem(16px);
          box-sizing: border-box;
          background: #fff;
          margin: 0 auto;
          border-radius: pxtorem(8px);
          color: #262626;
          .user_box {
            display: flex;
            align-items: center;
            margin-bottom: pxtorem(10px);
            img {
              width: pxtorem(34px);
              height: pxtorem(34px);
              border-radius: 50%;
            }
            span {
              font-size: pxtorem(14px);
              margin-left: pxtorem(10px);
              font-weight: 500;
            }
          }
          .text_con {
            .p_13 {
              font-size: pxtorem(13px);
              line-height: pxtorem(18px);
            }
            .img_box {
              margin-top: pxtorem(12px);
              img {
                width: pxtorem(56px);
                height: pxtorem(56px);
                border-radius: pxtorem(2px);
                object-fit:cover;
                &:not(:last-child) {
                  margin-right: pxtorem(8px);
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConsultDetail.vue